import { Roles } from '../../../constants/roles';

// Mirrors the roles the chat endpoint is guarded with on the API.
export const ChatAllowedRoles = [
	Roles.SuperAdmin,
	Roles.AccountManager,
	Roles.Compliance,
	Roles.Credit,
];

export const ChatSuggestions = [
	'How many loans are pending approval right now?',
	'List the investors waiting on IBAN approval.',
	'What were the total deposits this month?',
	'Which loans have overdue instalments?',
];

// Keep the tail only, so a long session cannot grow the stored thread unbounded.
export const MaxStoredMessages = 50;

export const ChatTitle = 'Souq Assistant';
export const ChatSubtitle = 'Ask about platform data';

export const ChatPanelDefaultWidth = 420;

export const ChatPanelMinWidth = 340;
export const ChatPanelMaxWidth = 720;

// On a narrow screen the 720px ceiling would leave nothing to read beside the panel.
const ChatPanelMaxViewportShare = 0.4;

export const clampChatPanelWidth = (width, viewportWidth) => {
	const available =
		viewportWidth || (typeof window === 'undefined' ? 0 : window.innerWidth);
	const ceiling = Math.max(
		ChatPanelMinWidth,
		Math.min(
			ChatPanelMaxWidth,
			Math.round(available * ChatPanelMaxViewportShare)
		)
	);
	return Math.round(Math.min(Math.max(width, ChatPanelMinWidth), ceiling));
};
